export default __webpack_public_path__ + "static/media/gm-pp-girl.c5a25717.webp";